<app-pasteurization-status-tile
  [dataPoints$]="dataPoints$"
  [installationId]="(installation$ | async)?.id"
  [systemId]="application.id">
</app-pasteurization-status-tile>

<app-mixit-x509-banner/>
@if (alarm$ | async) {
  <app-alarm-bar [alarm]="alarm$"> </app-alarm-bar>
}

<app-schematics-tile
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [showShadow]="false"
  [dataPoints$]="dataPoints$">
</app-schematics-tile>

<app-setpoint-tile
  [application]="application"
  [installation$]="installation$"
  [dataPoints$]="dataPoints$"
  [currentTemperatureDumbledoreId]="EEquipment.T_1_TOP">
</app-setpoint-tile>

<app-heat-meter-status-tile
  [installation$]="installation$"
  [application]="application"
  [dataPoints$]="dataPoints$"
  [schematic$]="schematic$">
</app-heat-meter-status-tile>

@if (pumpDevice$ | async) {
  <app-pump-status-tile
    [installation$]="installation$"
    [application]="application"
    [pumpType$]="pumpType$"
    [pumpDevice$]="pumpDevice$"
    [pumpOptions]="pumpOptions$ | async">
  </app-pump-status-tile>
}

@if (valveDevice$ | async) {
  <app-valve-status-tile
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id"
    [dataPoints$]="dataPoints$"
    [valveDevice$]="valveDevice$"
    [energyValve]="hasEnergyValve$ | async">
  </app-valve-status-tile>
}

@if (hasPrimaryTemperatureSensors$ | async) {
  <app-forward-return-chart-tile
    [title]="'mixing-loop-dashboard.primary-temp-chart-title' | translate"
    [applicationId]="application.id"
    forwardDumbledoreId="T_PF"
    returnDumbledoreId="T_PR"
    [dataPoints$]="dataPoints$"
    [userTrackingPeriodOptions]="{ category: 'application/cascadeTank', intervalPrefix: 'primaryTemperature' }">
  </app-forward-return-chart-tile>
}

<app-temperature-chart-tile
  [title]="'cascade-tank-dashboard.tank-one-temperatures' | translate"
  [applicationId]="application.id"
  [series]="tankOneChartSeries$ | async"
  [colors]="['#0068B4', '#009EE3', '#59B093']"
  [dataPoints$]="dataPoints$"
  [userTrackingPeriodOptions]="{ category: 'application/cascadeTank', intervalPrefix: 'tankOneTemperatures' }">
</app-temperature-chart-tile>

<app-temperature-chart-tile
  [title]="'cascade-tank-dashboard.tank-two-temperatures' | translate"
  [applicationId]="application.id"
  [series]="tankTwoChartSeries$ | async"
  [colors]="['#0068B4', '#009EE3', '#59B093']"
  [dataPoints$]="dataPoints$"
  [userTrackingPeriodOptions]="{ category: 'application/cascadeTank', intervalPrefix: 'tankTwoTemperatures' }">
</app-temperature-chart-tile>

<app-flow-heat-meter-chart-tile
  [dataPoints$]="dataPoints$"
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [userTrackingPeriodOptions]="{ category: 'application/cascadeTank', intervalPrefix: 'flowAndHeatMeter' }">
</app-flow-heat-meter-chart-tile>

<app-valve-chart
  [dataPoints$]="dataPoints$"
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [hasEnergyValve]="hasEnergyValve$ | async"
  [userTrackingPeriodOptions]="{ category: 'application/cascadeTank', intervalPrefix: 'valvePosition' }">
</app-valve-chart>

@if (hasEnergyValve$ | async) {
  <app-energy-valve-heat-and-flow-chart
    [dataPoints$]="dataPoints$"
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id">
  </app-energy-valve-heat-and-flow-chart>
}

@if (hasEnergyValve$ | async) {
  <app-energy-valve-temperature-chart
    [dataPoints$]="dataPoints$"
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id">
  </app-energy-valve-temperature-chart>
}

<app-water-meter-chart-tile
  [dataPoints$]="dataPoints$"
  [installationId]="(installation$ | async)?.id"
  [applicationId]="application.id"
  [userTrackingPeriodOptions]="{ category: 'application/cascadeTank', intervalPrefix: 'waterMeter' }">
</app-water-meter-chart-tile>
